import React from "react";
import {
  Dialog,
  DialogContent,
  DialogActions,
  Typography,
  makeStyles,
  Grid,
} from "@material-ui/core";
import Controls from "./controls/Controls";
import { useState } from "react";
import { useEffect } from "react";
import { getAllBanks, getAllPaymentMethods } from "../../../services";
import { Form, useForm } from "./useForm";
import axios from "axios";
import * as sweetalert from "sweetalert";
import packageJson from "../../../../package.json";
import { getEPaymentConfig } from "../../../services/EPaymentConfig";
import { WindowScrollController } from "@fullcalendar/core";
export const BaseUrl = packageJson.projectURlApi.BaseUrl;
const useStyles = makeStyles((theme) => ({
  dialog: {
    padding: theme.spacing(4),
    position: "absolute",
    top: theme.spacing(5),
  },
  dialogTitle: {
    textAlign: "center",
  },
  dialogContent: {
    textAlign: "center",
  },
  dialogAction: {
    justifyContent: "center",
  },
  titleIcon: {
    backgroundColor: theme.palette.secondary.light,
    color: theme.palette.secondary.main,
    "&:hover": {
      backgroundColor: theme.palette.secondary.light,
      cursor: "default",
    },
    "& .MuiSvgIcon-root": {
      fontSize: "8rem",
    },
  },
}));

export default function ConfirmDialog(props) {
  const [fundoption, setFundoption] = useState([]);
  const [paymentMethod, setPaymentMethod] = useState([]);
  const [Banks, setBanks] = useState([]);
  const [image, setImage] = useState("");
  const { confirmDialog, setConfirmDialog } = props;
  const classes = useStyles();
  const staff_type = localStorage.getItem("staff_type");
  const [loading, setLoading] = useState(false);
  const [Paymentconfigration, setGetPaymentconfigration] = useState([]);
  const [discount_fatora_bank, setDiscount_fatora_bank] = useState([]);
  const [increase_sell_percent, setIncrease_sell_percent] = useState([]);
  useEffect(() => {}, [props.id]);

  // useEffect(() => {
  //   getAllPaymentMethods().then((res) => {
  //     setPaymentMethod(res.data);
  //   });
  //   getAllBanks().then((res) => {
  //     setBanks(res);
  //   });
  //   getEPaymentConfig().then((res) => {
  //     setGetPaymentconfigration(res);
      
  //     // setIsLoading(true);
  //   });
  //   return () => {};
  // }, []);
 
  const initialFValues = {
    phone: props.phone,
    description:props.data1 !=='' ?  props.data1.description:'',
  };
  const validate = (fieldValues = loginInput) => {
    let temp = { ...errors };

    if ("description" in fieldValues) {
      if (fieldValues.description == "") {
        temp.description = "هذا الحقل مطلوب";
      } else {
        temp.description = "";
      }
    }

    setErrors({
      ...temp,
    });
    if (fieldValues == loginInput)
      return Object.values(temp).every((x) => x == "");
  };
  const handleInputChange2 = e => {
    
    const { name, value } = e.target

    setLogin({ ...loginInput, [name]: value });
  }
  const { loginInput, setLogin, errors, setErrors, handleInputChange } =
    useForm(initialFValues, true.validate);
    useEffect(() => {
     if(props.data1 !==''){

       setLogin({ ...loginInput, description: props.data1.description });
      }
     else {

       setLogin({ ...loginInput, description: '' });
      }
  
      
    },[props.data1]);
   
  const handleSubmit = (e) => {
    e.preventDefault();
    setLoading(true);
    if (validate()) {
      const data = {
        phone: initialFValues.phone,
        description: loginInput.description,
      };

      axios
        .post(`${BaseUrl}/api/addToMyCustomer`, data, {
          withCredentials: true,
        })
        .then((res) => {
          if (res.data.status == true) {
            setLoading(false);
            // localStorage.setItem("convert_mobile",initialFValues.phone.ToNumber());

            localStorage.setItem("convert_mobile",initialFValues.phone);
            sweetalert(res.data.msg, {
              className: "alert-div",
              button: {
                text: "تم",
              },
            }).then(() => {
            // window.location.reload();
            })
          } else if (res.data.status == false) {
            setLoading(false);
            sweetalert(res.data.msg, {
              className: "alert-div",
              button: {
                text: "تم",
              },
            });
          } else {
            setLoading(false);
            sweetalert(loginInput.error_list);
            setLogin({ ...loginInput, error_list: res.data.message });
          }
        });
    }
  };
  const handleSubmit2 = (e) => {
    e.preventDefault();
    setLoading(true);
    if (validate()) {
      const data = {
        id: props.data1.id,
        description: loginInput.description,
      };

      axios
        .post(`${BaseUrl}/api/updateMyCustomer`, data, {
          withCredentials: true,
        })
        .then((res) => {
          if (res.data.status == true) {
            setLoading(false);
            localStorage.setItem("convert_mobile",props.data1.phone);
            sweetalert(res.data.msg, {
              className: "alert-div",
              button: {
                text: "تم",
              },
            }).then(() => {
              window.location.reload();
              })
          } else if (res.data.status == false) {
            setLoading(false);
            sweetalert(res.data.msg, {
              className: "alert-div",
              button: {
                text: "تم",
              },
            });
          } else {
            setLoading(false);
            sweetalert(loginInput.error_list);
            setLogin({ ...loginInput, error_list: res.data.message });
          }
        });
    }
  };


  return (
    <Dialog open={confirmDialog.isOpen} classes={{ paper: classes.dialog }}>
      <DialogContent className={classes.dialogContent}>
        <Typography variant="h6">{confirmDialog.title}</Typography>
        <Typography variant="subtitle2">{confirmDialog.subTitle}</Typography>
      </DialogContent>
      <DialogActions
        className={classes.dialogAction}
        style={{ display: "flex", flexDirection: "column" }}
      >
        <Form className="form-group new-design" onSubmit={handleSubmit}>
          <Grid item lg={12} md={12} xs={12}>
            <Grid item md={12} xs={12}>
              <Controls.Input
                label="رقم الموبايل"
                name="phone"
                variant="outlined"
                fullWidth
                onChange={handleInputChange}
                className="form-control"
                value={initialFValues.phone}
                disabled
              />
            </Grid>
            <Grid item md={12} xs={12}>
              <Controls.Input
                label="الاسم"
                name="description"
                variant="outlined"
                fullWidth
                onChange={handleInputChange2}
                className="form-control"
                type="text"
                value={loginInput.description}
              />
            </Grid>
          </Grid>
          <Grid item lg={12} md={12} xs={12} style={{ marginTop: "15px" }}>
            <Controls.Button
              text="تراجع"
              color="default"
              onClick={() =>
                setConfirmDialog({ ...confirmDialog, isOpen: false })
              }
            />
            {loading === true ? (
              <Controls.Button
                type="submit"
                text=<div class="spinner center">
                  <div class="spinner-blade"></div>
                  <div class="spinner-blade"></div>
                  <div class="spinner-blade"></div>
                  <div class="spinner-blade"></div>
                  <div class="spinner-blade"></div>
                  <div class="spinner-blade"></div>
                  <div class="spinner-blade"></div>
                  <div class="spinner-blade"></div>
                  <div class="spinner-blade"></div>
                  <div class="spinner-blade"></div>
                  <div class="spinner-blade"></div>
                  <div class="spinner-blade"></div>
                </div>
                variant="contained"
                className="btn-submit loader-submit "
              ></Controls.Button>
            ) : (
              <>
                {props.data1 == "" ? (
                  <Controls.Button
                    text="إضافة"
                    color="secondary"
                    onClick={handleSubmit}
                  />
                ) : (
                  <Controls.Button
                    text="تعديل"
                    color="secondary"
                    onClick={handleSubmit2}
                  />
                )}
              </>
            )}
          </Grid>
        </Form>
      </DialogActions>
    </Dialog>
  );
}
